/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { WebAppCreateEditVideoEditorEditsMutationRequest, WebAppCreateEditVideoEditorEditsMutationResponse, WebAppCreateEditVideoEditorEdits401, WebAppCreateEditVideoEditorEdits403 } from "../models/WebAppCreateEditVideoEditorEdits";
import type { UseMutationOptions, UseMutationResult, QueryClient } from "@tanstack/react-query";
import { webAppCreateEditVideoEditorEdits } from "../axios/webAppCreateEditVideoEditorEdits";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const webAppCreateEditVideoEditorEditsMutationKey = () => [{ url: '/web-app/v1/video-editor/edits' }] as const

export type WebAppCreateEditVideoEditorEditsMutationKey = ReturnType<typeof webAppCreateEditVideoEditorEditsMutationKey>

export function webAppCreateEditVideoEditorEditsMutationOptions<TContext = unknown>(config: Partial<RequestConfig<WebAppCreateEditVideoEditorEditsMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = webAppCreateEditVideoEditorEditsMutationKey()
        return mutationOptions<WebAppCreateEditVideoEditorEditsMutationResponse, ResponseErrorConfig<WebAppCreateEditVideoEditorEdits401 | WebAppCreateEditVideoEditorEdits403>, {data: WebAppCreateEditVideoEditorEditsMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ data }) => {
            return webAppCreateEditVideoEditorEdits(data, config)
          },
        })

}

/**
 * @summary Create an edit from a source (response includes creator and published platforms)
 * {@link /web-app/v1/video-editor/edits}
 */
export function useWebAppCreateEditVideoEditorEdits<TContext>(options: 
{
  mutation?: UseMutationOptions<WebAppCreateEditVideoEditorEditsMutationResponse, ResponseErrorConfig<WebAppCreateEditVideoEditorEdits401 | WebAppCreateEditVideoEditorEdits403>, {data: WebAppCreateEditVideoEditorEditsMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<WebAppCreateEditVideoEditorEditsMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? webAppCreateEditVideoEditorEditsMutationKey()

          const baseOptions = webAppCreateEditVideoEditorEditsMutationOptions(config) as UseMutationOptions<WebAppCreateEditVideoEditorEditsMutationResponse, ResponseErrorConfig<WebAppCreateEditVideoEditorEdits401 | WebAppCreateEditVideoEditorEdits403>, {data: WebAppCreateEditVideoEditorEditsMutationRequest}, TContext>
          

          return useMutation<WebAppCreateEditVideoEditorEditsMutationResponse, ResponseErrorConfig<WebAppCreateEditVideoEditorEdits401 | WebAppCreateEditVideoEditorEdits403>, {data: WebAppCreateEditVideoEditorEditsMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<WebAppCreateEditVideoEditorEditsMutationResponse, ResponseErrorConfig<WebAppCreateEditVideoEditorEdits401 | WebAppCreateEditVideoEditorEdits403>, {data: WebAppCreateEditVideoEditorEditsMutationRequest}, TContext>
      
}